import React from 'react';
import { Shield, Lock, Users } from 'lucide-react';

const trustCards = [
  {
    icon: <Shield size={28} />,
    title: 'Tus historias son tuyas. Siempre.',
    description:
      'No vendemos, compartimos ni usamos tus datos para entrenar IA.',
  },
  {
    icon: <Lock size={28} />,
    title: 'Solo los que tú invites pueden escuchar',
    description:
      'Tus grabaciones son privadas por defecto. Solo los miembros que tú invites pueden acceder desde la app.',
  },
  {
    icon: <Users size={28} />,
    title: 'Tú decides quién puede ver, editar o solo escuchar',
    description:
      'Control total con roles de propietario, editor y lector. Tú decides quién tiene acceso a cada historia.',
  },
];

const TrustSecuritySection: React.FC = () => {
  return (
    <section className="py-8 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-6 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-serif font-semibold text-stone-900 mb-4">
            Sus recuerdos están seguros con nosotros
          </h2>
          <p className="text-lg text-stone-600">
            Sabemos que nos confías lo más importante de tu familia. Así lo protegemos:
          </p>
        </div>

        <div className="grid sm:grid-cols-3 gap-6 md:gap-8 max-w-4xl mx-auto">
          {trustCards.map((card, i) => (
            <div
              key={i}
              className="p-6 rounded-2xl bg-stone-50 border border-stone-100 hover:shadow-lg hover:-translate-y-1 transition-all duration-300 text-center"
            >
              <div className="w-14 h-14 bg-white rounded-xl shadow-sm flex items-center justify-center mx-auto mb-4 border border-stone-100 text-rose-500">
                {card.icon}
              </div>
              <h3 className="text-lg font-semibold text-stone-900 mb-2">
                {card.title}
              </h3>
              <p className="text-stone-600 text-sm leading-relaxed">
                {card.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustSecuritySection;
